export default __webpack_public_path__ + "static/media/twokitty-face.53d966c6.jpeg";